import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = {
  key: 2,
  style: {"margin-top":"10px"}
}

import Pagination from '@/components/Pagination.vue'
import { useRouter,useRoute } from 'vue-router'
import SelectBrand from '@/components/SelectElectronBrands.vue'
import SelectChannel from '../../components/SelectChannel.vue'
import { joinParams } from '@/utils/index'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { Types } from './enum'
import { getCurrentInstance, reactive,watch, ref,onMounted,onActivated } from 'vue'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelProductsList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const userType = store.state.user.userInfo.user_type as Number
    const userInfo = store.state.user.userInfo.channel_no
    const activeIndex = ref('1')
    const filters = reactive({
            channel_no: userInfo || '',//渠道号
            mft_id:'',              //厂家
            brand_id:      '',    //品牌名
            name:          '',    // 商品名称
            type:          '',    //类型
            status:        '',    //状态
            operator_status: '',  //操作状态 
            tmd_type: 2,         //1是甜蜜兑 2是非甜蜜兑
            page:           1,    // 当前页码
            page_size:     10,    // 每页显示条数
    })
    const state =reactive({
        product_ids:[],
        data_type:'1'
    })
    const tableData = ref([])
    const total = ref(0)
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no||val : ''
    }
    const onFactoryChange= (val) => {
        filters.mft_id = val
    }
    const url = ref('')
    const handleSelect = (key: string, keyPath: string[]) => {
        if(key == '1'){
            //电子券商品
            filters.tmd_type = 2
            getList()
            state.data_type = '1'
        }else{
            //甜蜜兑商品
            filters.tmd_type = 1
            getList()
            state.data_type = '2'
        }
    }
    const onTypeChange = (val) => {
        if(val == '1' || val == '2'){
            activeIndex.value = '1'
        }else{
            activeIndex.value = '2'
        }
    }
    // 跳转至编辑页
    const toEdit = (row,t) => {
        router.push(`/electron/products-edit?id=${row.id}&t=${t}`)
    }
    const out = (type) => {
        window.open(`${Keys.baseUrl}/cake_api/productChannelList?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export_type=${type}`)
    }
    //上下架
    const onShelf = (channel_no,id) => {
        proxy.$confirm('是否修改该商品状态', '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/cake_api/productChannelStatus', {channel_no,channel_product_id:id}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: msg })
                getList()
            })
        }).catch(() => {
            console.log('取消修改')
        })
    }
    // 获取列表数据
    const getList = () => {
        if(route.query.channel_no) {
            filters.channel_no = route.query.channel_no as string
        }
        if (!filters.channel_no) { return proxy.$message({ type: 'error', message: '请选择渠道' }) }
        proxy.$http.get('/cake_api/productChannelList', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    const onBrandChange = (val) => {
        filters.brand_id = val
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    // onMounted(() => {
    //     route.query.channel_no
    //     getList()
    // })
    onActivated(() => {
        route.query.channel_no
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(userType)!=3)
        ? (_openBlock(), _createBlock(SelectChannel, {
            key: 0,
            modelValue: filters.channel_no,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.channel_no) = $event)),
            onChannelChange: onChannelChange
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "电子券名称",
        style: {"width":"150px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(SelectBrand, { onBrandChange: onBrandChange }),
      (state.data_type=='1')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "filter-item",
            filterable: "",
            modelValue: filters.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.type) = $event)),
            placeholder: "类型",
            clearable: "",
            onChange: onTypeChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _unref(Types)[1],
                value: 1
              }, null, 8, ["label"]),
              _createVNode(_component_el_option, {
                label: _unref(Types)[2],
                value: 2
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_unref(userType)!=3)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 2,
            class: "filter-item",
            filterable: "",
            modelValue: filters.operator_status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.operator_status) = $event)),
            placeholder: "自-商品状态",
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "全部",
                value: -1
              }),
              _createVNode(_component_el_option, {
                label: "下架",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "上架",
                value: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.status) = $event)),
        placeholder: "渠道商品状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: -1
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "上架",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "售罄",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (_unref(userType)!=3)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (out(1)))
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("批量导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_menu, {
      "default-active": activeIndex.value,
      class: "el-menu-demo",
      mode: "horizontal",
      onSelect: handleSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("电子券商品")
          ])),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("甜蜜兑商品")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          width: "100",
          label: "电子券名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "类型"
        }),
        (_unref(userType)!=3 && state.data_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "sxd_discount",
              label: "商家折扣"
            }))
          : _createCommentVNode("", true),
        (_unref(userType)!=3)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "channel_discount",
              label: "渠道折扣"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "cat_name",
          label: "分类"
        }),
        (_unref(userType)!=3)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "operator_status",
              width: "100",
              label: "自-商品状态"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.operator_status == 1 ? '上架' : '下架'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "渠道商品状态"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status == 1 ? '上架' : scope.row.status == 0 ? '下架' : '售罄'), 1)
          ]),
          _: 1
        }),
        (state.data_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "service_charge",
              label: "服务费"
            }))
          : _createCommentVNode("", true),
        (state.data_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              prop: "tax_Point",
              label: "税点"
            }))
          : _createCommentVNode("", true),
        (state.data_type!=2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              prop: "price",
              label: "售价"
            }))
          : _createCommentVNode("", true),
        (state.data_type!=2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              prop: "clearing_price",
              width: "100",
              label: "渠道结算价"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "up_time",
          label: "更新时间",
          width: "145"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              (_unref(userType)==3 && state.data_type==2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    disabled: scope.row.status ==2 && _unref(userType)==3 ,
                    title: scope.row.status ==2 && _unref(userType)==3 ? '售罄的商品不可编辑':'',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(scope.row,2))
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode(" 查看 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    disabled: scope.row.status ==2 && _unref(userType)==3 ,
                    title: scope.row.status ==2 && _unref(userType)==3 ? '售罄的商品不可编辑':'',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(scope.row,2))
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" 编辑 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"])),
              (_unref(userInfo))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    (scope.row.status == 0)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          disabled: scope.row.status ==2 && _unref(userType)==3 ,
                          title: "售罄的商品不可进行上下架",
                          type: "success",
                          size: "small",
                          onClick: ($event: any) => (onShelf(scope.row.channel_no,scope.row.id))
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" 上架 ")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : _createCommentVNode("", true),
                    (scope.row.status == 1)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          disabled: scope.row.status ==2 && _unref(userType)==3 ,
                          title: "售罄的商品不可进行上下架",
                          type: "warning",
                          size: "small",
                          onClick: ($event: any) => (onShelf(scope.row.channel_no,scope.row.id))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" 下架 ")
                          ])),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})